<template>
	<div class="container">
		<el-card>
			<div slot="header">销户记录查询</div>
			<div style="height: 100%">
				<el-button type="primary" size="small" @click="viewDetailDialog">查看详情</el-button>
				<el-button type="primary" class="iconfont icon-excel" size="small"
					style="background-color: #23c6c8 !important" @click="exportToExcel">导出</el-button>
				<el-form ref="form" :model="form" label-width="80px" size="small" class="searchForm">
					<el-form-item label="创建时间" label-width="70px">
						<el-date-picker v-model="queryParams.createStartTime" type="datetime" placeholder="选择开始日期"
							class="searchTag" value-format="yyyy-MM-dd HH:mm:ss" :clearable="true">
						</el-date-picker>
						<label> 到 </label>
						<el-date-picker v-model="queryParams.createEndTime" type="datetime" placeholder="选择结束日期"
							class="searchTag" value-format="yyyy-MM-dd HH:mm:ss" :clearable="true">
						</el-date-picker>
					</el-form-item>
					<el-form-item label="商户编号">
						<el-input v-model="queryParams.code" class="searchTag" clearable></el-input>
					</el-form-item>
					<el-form-item label="商户名称">
						<el-select v-model="queryParams.name" placeholder="" clearable filterable class="searchTag">
							<el-option v-for="item in lesseeNameOptions" :key="item.name" :label="item.name"
								:value="item.name">
							</el-option>
						</el-select>
					</el-form-item>
					<el-button type="primary" icon="el-icon-search" size="small" style="margin-left: 10px"
						@click="handleQuery">搜索</el-button>
				</el-form>
				<div class="tableStyle">
					<el-table :data="tableData" style="width: 100%" height="92%" highlight-current-row
						id="cancelAccountRecordTable" ref="cancelAccountRecordTable"
						@current-change="handleCurrentChange">
						<el-table-column type="index" width="50" label="序号" align="center" :index="indexMethod">
						</el-table-column>
						<el-table-column prop="editorTime" label="创建时间" width="160" align="center">
						</el-table-column>
						<el-table-column prop="editorName" label="创建人" width="150" align="center">
						</el-table-column>
						<el-table-column prop="code" label="商户编号" width="150" align="center">
						</el-table-column>
						<el-table-column prop="name" label="商户名称" width="150" align="center">
						</el-table-column>
						<el-table-column prop="phone" label="联系人电话" width="150" align="center">
						</el-table-column>
						<el-table-column prop="detailAddress" label="联系地址" align="center">
						</el-table-column>
						<el-table-column prop="cancelName" label="销户人" width="160" align="center">
						</el-table-column>
						<el-table-column prop="cancelTime" label="销户时间" width="160" align="center">
						</el-table-column>
						<el-table-column prop="remark" label="备注" width="150" align="center">
						</el-table-column>
					</el-table>
					<div class="block">
						<el-pagination v-show="total > 0" @size-change="handleQuery" @current-change="handleQuery"
							:current-page.sync="queryParams.current" :page-sizes="[100, 200, 400, 600, 800, 1000]"
							:page-size.sync="queryParams.size" layout="total, sizes, prev, pager, next, jumper"
							:total="total">
						</el-pagination>
					</div>
				</div>
			</div>
		</el-card>
		<!-- 查看详情 -->
		<el-dialog title="查看详情" :visible.sync="detailDialogVisible" width="1100px" class="detailDialogClass">
			<div>
				<el-form ref="cancelRecordForm" :model="cancelRecordForm" label-width="150px" size="small">
					<el-row :gutter="10">
						<el-col :md="12">
							<el-form-item label="商户编号" prop="code">
								<el-input v-model="cancelRecordForm.code" placeholder="" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :md="12">
							<el-form-item label="商户名称" prop="name">
								<el-input v-model="cancelRecordForm.name" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :md="12">
							<el-form-item label="商户联系人" prop="contactMan">
								<el-input v-model="cancelRecordForm.contactMan" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :md="12">
							<el-form-item label="电话" prop="phone">
								<el-input v-model="cancelRecordForm.phone" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :md="12">
							<el-form-item label="区域" prop="districtId">
								<el-cascader v-model="cancelRecordForm.districtId" :options="districtIdOptions"
									:props="props" disabled></el-cascader>
							</el-form-item>
						</el-col>
						<el-col :md="12">
							<el-form-item label="地址" prop="address">
								<el-input v-model="cancelRecordForm.address" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :md="12">
							<el-form-item label="小程序联系人" prop="systemAdmin">
								<el-input v-model="cancelRecordForm.systemAdmin" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :md="12">
							<el-form-item label="电话" prop="systemAdminPhone">
								<el-input v-model="cancelRecordForm.systemAdminPhone" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :md="12">
							<el-form-item label="商户电账户当前金额" prop="electricBalance">
								<el-input v-model="cancelRecordForm.electricBalance" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :md="12">
							<el-form-item label="业态" prop="type">
								<el-select v-model="cancelRecordForm.type" placeholder="请选择" style="width: 100%"
									disabled>
									<el-option v-for="item in lesseeTypeOptions" :key="item.key" :label="item.value"
										:value="item.key"></el-option>
								</el-select>
							</el-form-item>
						</el-col>
					</el-row>
					<el-row :gutter="10">
						<el-col :md="12">
							<el-form-item label="商户水账户当前金额" prop="waterBalance">
								<el-input v-model="cancelRecordForm.waterBalance" disabled></el-input>
							</el-form-item>
						</el-col>
						<el-col :span="12">
							<el-form-item label="备注" prop="remark">
								<el-input v-model="cancelRecordForm.remark" disabled></el-input>
							</el-form-item>
						</el-col>
					</el-row>
				</el-form>
			</div>
			<el-card>
				<div slot="header">已绑定电表信息</div>
				<div>
					<el-table :data="electricTableData" style="width: 100%">
						<el-table-column prop="meterAddr" label="电表编号" align="center">
						</el-table-column>
						<el-table-column prop="model" label="电表型号" align="center">
						</el-table-column>
						<el-table-column prop="type" label="电表制式" align="center">
						</el-table-column>
						<el-table-column prop="producer" label="电表厂商" align="center">
						</el-table-column>
						<el-table-column prop="ctRatio" label="CT变比" align="center">
						</el-table-column>
						<el-table-column prop="startDegree" label="开始度数(kW·h)" align="center">
						</el-table-column>
						<el-table-column prop="endDegree" label="结束度数(kW·h)" align="center">
						</el-table-column>
						<el-table-column prop="remark" label="备注" align="center">
						</el-table-column>
					</el-table>
				</div>
			</el-card>
			<el-card>
				<div slot="header">已绑定水表信息</div>
				<div>
					<el-table :data="waterTableData" style="width: 100%">
						<el-table-column prop="meterAddr" label="水表编号" align="center">
						</el-table-column>
						<el-table-column prop="model" label="水表型号" align="center">
						</el-table-column>
						<el-table-column prop="producer" label="水表厂商" align="center">
						</el-table-column>
						<el-table-column prop="startDegree" label="起始水底数(m³)" align="center">
						</el-table-column>
						<el-table-column prop="endDegree" label="结束水底数(m³)" align="center">
						</el-table-column>
						<el-table-column prop="remark" label="备注" align="center">
						</el-table-column>
					</el-table>
				</div>
			</el-card>
		</el-dialog>
	</div>
</template>

<script>
	import {
		selectInvalidList,
		cancelAccountDetail,
		selectListLesseeName,
	} from '../../api/merchant/cancelAccountRecord';
	import {
		translateObjectEmptyAttributeToNull,
		cascaderAfferentArray,
	} from '../../untils/func';
	import dictionaryConstant from '../../constant/dictionaryConstant';
	import exportTable from '../../untils/exportTable';
	import {
		selectDictionaryListByName,
		selectComboboxTreeData,
	} from '../../api/comboboxLoad';
	export default {
		data() {
			return {
				form: {},
				cancelRecordForm: {
					code: '',
					name: '',
					contactMan: '',
					systemAdmin: '',
					phone: '',
					systemAdminPhone: '',
					address: '',
					type: '',
					electricBalance: '',
					waterBalance: '',
					districtId: [],
				},
				tableData: [],
				// 查询参数
				queryParams: {
					current: 1,
					size: 100,
					createStartTime: '',
					createEndTime: '',
				},
				loading: false,
				total: 0,
				currentRow: null,
				detailDialogVisible: false,
				electricTableData: [],
				waterTableData: [],
				lesseeTypeOptions: [], //业态 options
				districtIdOptions: [], //区域 options
				props: {
					expandTrigger: 'hover',
					emitPath: false,
				},
				lesseeNameQueryParams: {
					current: 1,
					size: 10000,
				},
				lesseeNameOptions: [],
			};
		},
		created() {
			this.init();
		},
		mounted() {},
		watch: {},
		methods: {
			async init() {
				await this.handleQuery();
				// 下拉列表
				await this.getLesseeType();
				await this.getSelectComboboxTreeData();
				await this.getLesseeNameOption();
			},
			async handleQuery() {
				this.loading = true;
				let param = this.queryParams;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectInvalidList(param).then();
				this.tableData = response.data;
				// console.log(this.tableData);
				this.total = response.total;
				this.loading = false;
				this.cancelChoose();
			},
			cancelChoose() {
				this.$refs.cancelAccountRecordTable.setCurrentRow();
				this.currentRow = null;
			},
			// 获取商户名称下拉框
			async getLesseeNameOption() {
				let param = this.lesseeNameQueryParams;
				param = translateObjectEmptyAttributeToNull(param);
				const response = await selectListLesseeName(param).then();
				this.lesseeNameOptions = response.data;
			},
			// 查看详情接口
			async getCancelAccountDetail() {
				const res = await cancelAccountDetail({
					id: this.currentRow
				}).then();
				this.cancelRecordForm = res.data.openAccountHeadVo;
				this.cancelRecordForm.districtId = cascaderAfferentArray(
					this.cancelRecordForm.districtData
				);
				this.electricTableData = res.data.meterList;
				this.waterTableData = res.data.waterList;
			},
			async viewDetailDialog() {
				if (this.currentRow == null) {
					this.$message.error('请先选择某条数据！');
				} else {
					this.detailDialogVisible = true;
					await this.getCancelAccountDetail();
				}
			},
			// 单选表格某一行
			handleCurrentChange(val) {
				if (val == null) {
					return;
				} else {
					this.currentRow = val.id;
				}
			},
			// 导出表格
			async exportToExcel() {
				if (this.tableData.length === 0) {
					this.$message.warning('无数据');
					return;
				} else {
					let size = this.queryParams.size;
					this.queryParams.size = this.total;
					this.queryParams.current = 1;
					await this.handleQuery();
					exportTable.exportExcel('cancelAccountRecordTable', '销户记录');
					this.queryParams.size = size;
					await this.handleQuery();
				}
			},
			indexMethod(index) {
				let num =
					this.queryParams.size * (this.queryParams.current - 1) + index + 1;
				return num;
			},

			// 获取业态下拉列表数据
			async getLesseeType() {
				const res = await selectDictionaryListByName(
					dictionaryConstant.LESSEE_TYPE
				).then();
				this.lesseeTypeOptions = res.data;
			},
			// 区域下拉框
			async getSelectComboboxTreeData() {
				const res = await selectComboboxTreeData().then();
				this.districtIdOptions = res.data;
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		padding: 0 10px;
		height: 100%;
	}

	.searchForm {
		margin-top: 15px;

		/deep/ .el-form-item {
			margin-bottom: 10px;
		}
	}

	/deep/ .el-card__header {
		background-color: var(--secondColor) !important;
		color: var(--whiteColor);
	}

	/deep/ .el-form-item {
		display: inline-block;
	}

	.searchTag {
		width: 200px;
	}

	.tableStyle {
		height: calc(100% - 80px);
	}

	@media screen and (max-width: 1560px) {
		.tableStyle {
			height: calc(100% - 90px);
		}
	}

	.detailDialogClass {
		/deep/ .el-form-item {
			margin-bottom: 10px !important;
			width: 100%;
		}

		/deep/ .el-card__header {
			padding: 10px 20px;
		}

		/deep/ .el-card__body {
			padding: 10px;
		}

		/deep/ .el-select,
		.el-cascader {
			width: 100%;
		}

		/deep/ .el-table .el-table__cell {
			padding: 6px 0;
		}
	}

	.block {
		margin-top: 10px;
	}
</style>
